import { ProCard } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { EntityDeleteButton } from '@app/icare/components/entity/EntityDeleteButton'
import { EntityDeletedBanner } from '@app/icare/components/entity/EntityDeletedBanner'
import { ArticleId } from '@app/icare/entities/article/schema/Article'
import { useEntityDeletion } from '@app/icare/hooks/useEntityDeletion'
import { t } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { zodParams } from '@pkg/db/utils'
import { useRouterTabs } from '@pkg/ui/hooks'
import { usePageContainerOverride } from '@pkg/ui/layout/PageContainer'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { Tabs } from 'antd'
import { z } from 'zod'

export const Route = createFileRoute('/_app/artikel/$id')({
  component: RouteComponent,
  params: zodParams(z.object({ id: ArticleId.ref })),
  validateSearch: zodValidator(
    z.object({
      category: z.string().optional(),
      tab: z.enum(['general', 'relations']).optional(),
    }),
  ),
  loader: () => ({
    breadcrumb: {
      label: t`Artikel`,
      to: '/artikel',
    },
  }),
})

function RouteComponent() {
  const { id } = Route.useParams()

  const { data } = useQuery(localQueryEntityOptions(id))
  const deletion = useEntityDeletion({ data })
  const { t } = useLingui()
  const title = data?.id ? data.name || data.pzn : 'Neuer Eintrag'
  const tabs = useRouterTabs()

  usePageContainerOverride(
    {
      header: {
        title,
        extra: <EntityDeleteButton {...deletion} />,
        footer: (
          <Tabs
            {...tabs}
            items={[
              {
                key: `/artikel/${id}`,
                label: t`Allgemein`,
              },
              {
                key: `/artikel/${id}/relations`,
                label: t`Beziehungen`,
              },
            ]}
          />
        ),
      },
    },
    [title, tabs.activeKey, deletion.isDeleted, deletion.isPending, data, t],
  )

  if (!data) {
    return <ProCard loading />
  }

  return (
    <>
      <EntityDeletedBanner {...deletion} />
      <Outlet />
    </>
  )
}
